import { endpoints } from '../endpoints'
import { http } from '../http'
import { ObituarySnippet, SearchPaginationParams } from '../../types'

interface ObituarySnippetAPI {
  loadAll: (params: SearchPaginationParams) => Promise<ObituarySnippet[]>
}

export const obituarySnippets: ObituarySnippetAPI = {
  loadAll: async ({ limit, page, search }) => {
    if (search) {
      return await http.get(
        `${endpoints.obituarySnippets}?limit=${limit}&page=${page}&search=${search}`,
      )
    }

    return await http.get(`${endpoints.obituarySnippets}?limit=${limit}&page=${page}`)
  },
}
